import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=2f24828f&scoped=true&lang=pug&"
import script from "./Metric.vue?vue&type=script&setup=true&lang=js&"
export * from "./Metric.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Metric.vue?vue&type=style&index=0&id=2f24828f&prod&lang=scss&"
import style1 from "./Metric.vue?vue&type=style&index=1&id=2f24828f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24828f",
  null
  
)

export default component.exports